import React from 'react';
import { Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { Extender } from '@gamiphy/muffin';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { darken } from '@gamiphy/utils/color';
import { ButtonMuffin } from './components/Button.muffin';
import { TabMuffin } from './components/Tab.muffin';
import { useTabs } from './hooks';

const BarContent = Extender<{}>(observer(({ useStyles }) => {
  const classes = useStyles({
    open: UiStore.opened || UiStore.fullBar,
  });

  const tabs = useTabs();

  return (
    <Grid
      className={classes.root}
      container
      alignItems="center"
      justifyContent="center"
    >
      <Grid
        className={classes.content}
        container
        alignItems="center"
        justifyContent="space-between"
        direction="column"
        wrap="nowrap"
        spacing={1}
      >
        <Grid item>
          <ButtonMuffin />
        </Grid>
        {tabs.map((tab) => (
          <Grid className={classes.item} item key={tab.title}>
            <TabMuffin tabInfo={tab} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}), {
  styles: (theme) => ({
    '@global': {
      html: {
        fontSize: 10,
      },
      body: {
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
      },
    },
    root: {
      backgroundColor: theme.palette.primary.main,
      minHeight: 'max-content',
      maxHeight: '100%',
      width: '100%',
      position: 'relative',
      borderRadius: '20px',
      border: 'solid 1px',
      borderColor: darken(theme.palette.primary.main, 35),
    },
    item: {
      transition: 'all 1s ease-in-out 1s',
    },
    content: {
      height: '100%',
      padding: theme.spacing(1),
      transition: 'all 1s ease-in-out',
    },
    back: {
      backgroundColor: theme.palette.text.secondary,
      color: theme.palette.primary.main,
      borderRadius: '50%',
      cursor: 'pointer',
      width: '2.4rem',
      height: '2.4rem',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
      },
    },
  }),
});

export default BarContent;
